const modals = {
  SOME_ID: 'some-id',
  EDIT_ORG_MODAL: 'edit-org-modal',
  WARNING_MODAL: 'warning-modal',
  DUPLICATE_MODAL: 'duplicate-modal',
  ORGANIZATION_DUPLICATE_MODAL: 'organization-duplicate-modal',
  DUPLICATE_WARNING_MODAL: 'duplicate-warning-modal',
  CREATE_USER_MODAL: 'create-user-modal',
  DISABLE_USER_CONFIRMATION_MODAL: 'disable-user-confirmation-modal',
  DISABLE_ORG_CONFIRMATION_MODAL: 'disable-org-confirmation-modal',
  DELETE_RECIPIENT_CONFIRMATION_MODAL: 'delete-recipient-confirmation-modal',
  DELETE_USER_CONFIRMATION_MODAL: 'delete-user-confirmation-modal',
};

export default modals;
